import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const HotelTableHeader = () => {
    const styles = StyleSheet.create({
        Hotelcontainer: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4',
            alignItems : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px'
        },
        Location: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        form: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        to:{
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        description: {
            width : '25%',
            fontSize : "11px",
            color : "#333333"
        },
    });
    return (
        <Fragment>
            <View style={styles.Hotelcontainer}>
                <Text style={styles.Location}>Location</Text>
                <Text style={styles.form}>From</Text>
                <Text style={styles.to}>to</Text>
                <Text style={styles.description}>Description</Text>
            </View>
        </Fragment>
    )
}

export default HotelTableHeader